import { Routes } from '@angular/router';
import { AuthGuard } from './auth/guards/auth.guard';
import { ActivationGuard } from './auth/guards/activation.guard';
import { DashboardLayoutComponent } from './layouts/dashboard/dashboard.component';
import { TitleService } from './shared/services/title.service';
import { inject } from '@angular/core';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: '',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'account',
        loadComponent: () => 
          import('./pages/account/account.component').then(m => m.AccountComponent),
        resolve: {
          title: () => {
            const titleService = inject(TitleService);
            titleService.setTitle('Your Account Hub');
            return true;
          }
        }
      },
      {
        path: 'dashboard',
        loadComponent: () => 
          import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent),
        resolve: {
          title: () => {
            const titleService = inject(TitleService);
            titleService.setTitle('Dashboard');
            return true;
          }
        }
      },
      {
        path: 'recent-ads',
        loadComponent: () => 
          import('./pages/recent-ads/recent-ads.component').then(m => m.RecentAdsComponent),
        resolve: {
          title: () => {
            const titleService = inject(TitleService);
            titleService.setTitle('Recent Ad Performance');
            return true;
          }
        }
      },
      {
        path: 'ad-balance',
        loadComponent: () => 
          import('./pages/ad-balance/ad-balance.component').then(m => m.AdBalanceComponent),
        resolve: {
          title: () => {
            const titleService = inject(TitleService);
            titleService.setTitle('Ad Balance & Billing');
            return true;
          }
        }
      },
      {
        path: 'pixel-tracking',
        loadComponent: () => 
          import('./pages/pixel-tracking/pixel-tracking.component').then(m => m.PixelTrackingComponent),
        resolve: {
          title: () => {
            const titleService = inject(TitleService);
            titleService.setTitle('Pixel & Tracking Setup');
            return true;
          }
        }
      },
      {
        path: 'create-ad',
        loadComponent: () => 
          import('./pages/create-ad/create-ad.component').then(m => m.CreateAdComponent),
        resolve: {
          title: () => {
            const titleService = inject(TitleService);
            titleService.setTitle('Create Ad');
            return true;
          }
        }
      },
      {
        path: 'guides',
        loadComponent: () => 
          import('./pages/guides/guides.component').then(m => m.GuidesComponent),
        resolve: {
          title: () => {
            const titleService = inject(TitleService);
            titleService.setTitle('Training Hub');
            return true;
          }
        }
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      }
    ],
    canActivate: [AuthGuard, ActivationGuard],
  },
  {
    path: '**',
    redirectTo: ''
  }
];
